module.exports = __webpack_public_path__ + "assets/img/budapark6-1280.af5f6b58.webp";